import React from "react";
import { AFFILIATE_URL } from "../mock/mitolynMock";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white text-slate-900 flex flex-col">
      <header className="bg-[#0b4434] py-4">
        <div className="max-w-5xl mx-auto px-4 flex justify-center">
          <a
            href={AFFILIATE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_fc80331a-96f2-46e1-a59f-214c25fdb97e/artifacts/stqswucd_image.png"
              alt="MITOLYN"
              className="h-10 w-auto"
            />
          </a>
        </div>
      </header>
      <main className="flex-1 py-10 md:py-12">
        <div className="max-w-3xl mx-auto px-4 md:px-0 text-sm md:text-base leading-relaxed space-y-4">
          <h1 className="text-3xl md:text-4xl font-extrabold text-center mb-6">Privacy</h1>

          <div className="mb-6 flex justify-center">
            <a
              href={AFFILIATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex flex-col items-center justify-center rounded-full bg-[#ffdd4a] px-6 py-3 text-slate-900 font-semibold text-base md:text-lg shadow-md hover:bg-[#ffe879] transition-colors"
            >
              <span>
                <strong>
                  Click <u>here</u> to discover more about Mitolyn
                </strong>
              </span>
              <span className="text-xs md:text-sm">
                and reveal special discounted offers!
              </span>
            </a>
          </div>

          {/* Main privacy content closely mirrors the original Mitolyn Privacy page, formatted into paragraphs for readability. */}
          <p>
            Your privacy is very important to us. We want to make your experience on the Internet as enjoyable and
            rewarding as possible, and we want you to use the Internet's vast array of information, tools, and
            opportunities with complete confidence.
          </p>

          <p>
            We have created this Privacy Policy to demonstrate our firm commitment to privacy and security. This
            Privacy Policy describes how our company collects information from all end users of our Internet services
            (the "Services")  b4 those who access some of our Services but do not have accounts ("Visitors") as well as
            those who may purchase Products and/or pay a monthly service fee to subscribe to the Service ("Members")
             b4 what we do with the information we collect, and the choices Visitors and Members have concerning the
            collection and use of such information. We request that you read this Privacy Policy carefully.
          </p>

          <p>
            <strong>Personal Information Our Company Collects and How It Is Used</strong>
          </p>

          <p>
            <strong>Introduction:</strong> Our company collects information in different ways from Visitors and
            Members who access the various parts of our Services and the network of Web sites accessible through our
            Service. We use this information primarily to provide a customized experience as you use our Products and
            Services, and generally, do not share this information with third parties. However, we may disclose
            personal information collected if we have received your permission beforehand or in very special
            circumstances, such as when we believe that such disclosure is required by law or other special cases
            described below.
          </p>

          <p>
            <strong>Registration:</strong> Members may be asked to provide certain personal information when they
            sign up for our Products or Services including name, address, telephone number, billing information (such
            as a credit card number), and the type of personal computer being used to access the Services. The
            personal information collected from Members during the registration process is used to manage each
            Member's account (such as for billing purposes). This information is not shared with third parties,
            unless specifically stated otherwise or in special circumstances.
          </p>

          {/* ... additional sections from the privacy policy, including cookies, California rights, data security, and opting out ... */}

          <div className="mt-8 mb-4 flex justify-center">
            <a
              href={AFFILIATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex flex-col items-center justify-center rounded-full bg-[#ffdd4a] px-6 py-3 text-slate-900 font-semibold text-base md:text-lg shadow-md hover:bg-[#ffe879] transition-colors"
            >
              <span>
                <strong>
                  Click <u>here</u> to discover more about Mitolyn
                </strong>
              </span>
              <span className="text-xs md:text-sm">
                and reveal special discounted offers!
              </span>
            </a>
          </div>
        </div>
      </main>
      <footer className="bg-[#0b4434] text-white text-xs py-6">
        <div className="max-w-5xl mx-auto px-4 space-y-3">
          <div className="flex justify-center gap-6">
            <a href="/terms" className="hover:underline">
              Terms
            </a>
            <a href="/privacy" className="hover:underline">
              Privacy
            </a>
          </div>
          <p className="text-[11px] leading-snug text-center text-teal-100">
            Statements found on this website have not been evaluated by the Food and Drug Administration. Products
            on this website are not intended to diagnose, treat, cure, or prevent any disease. If you are pregnant,
            nursing, taking medication, or have a medical condition, consult your physician before using our
            products. ClickBank ae is a registered trademark of Click Sales, Inc., a Delaware corporation located at
            1444 S. Entertainment Ave., Suite 410 Boise, ID 83709, USA and used by permission. ClickBank's role as
            retailer does not constitute an endorsement, approval or review of these products or any claim,
            statement or opinion used in promotion of these products.
          </p>
        </div>
      </footer>
    </div>
  );
}
